import './styles/NumPadStyle.css';
import { HiOutlineBackspace } from 'react-icons/hi2';
import { BsCheck2Circle } from 'react-icons/bs';

interface NumPadProps {
  onClickButton(option: string): void;
  disabled?: boolean;
}

enum ButtonType {
  DEFAULT = 'default',
  SUCCESS = 'success',
  CANCEL = 'cancel',
}

const numpadElements = [
  {
    key: '1',
    content: '1',
    option: '1',
    buttonType: ButtonType.DEFAULT,
  },
  {
    key: '2',
    content: '2',
    option: '2',
    buttonType: ButtonType.DEFAULT,
  },
  {
    key: '3',
    content: '3',
    option: '3',
    buttonType: ButtonType.DEFAULT,
  },
  {
    key: '4',
    content: '4',
    option: '4',
    buttonType: ButtonType.DEFAULT,
  },
  {
    key: '5',
    content: '5',
    option: '5',
    buttonType: ButtonType.DEFAULT,
  },
  {
    key: '6',
    content: '6',
    option: '6',
    buttonType: ButtonType.DEFAULT,
  },
  {
    key: '7',
    content: '7',
    option: '7',
    buttonType: ButtonType.DEFAULT,
  },
  {
    key: '8',
    content: '8',
    option: '8',
    buttonType: ButtonType.DEFAULT,
  },
  {
    key: '9',
    content: '9',
    option: '9',
    buttonType: ButtonType.DEFAULT,
  },
  {
    key: 'back',
    content: <HiOutlineBackspace />,
    option: 'back',
    buttonType: ButtonType.CANCEL,
  },
  {
    key: '0',
    content: '0',
    option: '0',
    buttonType: ButtonType.DEFAULT,
  },
  {
    key: 'go',
    content: <BsCheck2Circle />,
    option: 'go',
    buttonType: ButtonType.SUCCESS,
  },
];
const NumPad: React.FC<NumPadProps> = ({ onClickButton, disabled }) => {
  return (
    <div className="num-pad-container">
      {numpadElements.map((element) => {
        return (
          <button
            key={element.key}
            disabled={disabled}
            onClick={() => onClickButton(element.option)}
            className={`num-pad-button ${element.buttonType} stepOn`}
          >
            {element.content}
          </button>
        );
      })}
    </div>
  );
};

export { NumPad };
